import { render, staticRenderFns } from "./p2LoginView.vue?vue&type=template&id=3f77db7b&scoped=true"
import script from "./p2LoginView.vue?vue&type=script&lang=js"
export * from "./p2LoginView.vue?vue&type=script&lang=js"
import style0 from "./p2LoginView.vue?vue&type=style&index=0&id=3f77db7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f77db7b",
  null
  
)

export default component.exports